import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=20ea28a2&"
import script from "./side-nav.vue?vue&type=script&lang=js&"
export * from "./side-nav.vue?vue&type=script&lang=js&"
import style0 from "./side-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ea28a2')) {
      api.createRecord('20ea28a2', component.options)
    } else {
      api.reload('20ea28a2', component.options)
    }
    module.hot.accept("./side-nav.vue?vue&type=template&id=20ea28a2&", function () {
      api.rerender('20ea28a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/catalog/side-nav.vue"
export default component.exports